<script>
    // @ts-nocheck
    import ShowEye from '../Icons/custom/ShowEye.svelte'
    import Close from '../Icons/custom/Close.svelte'
    import { Typography } from '../UI'
    import { fade } from 'svelte/transition'
    import { flip } from 'svelte/animate'
    import { crossfade, scale } from 'svelte/transition'
    import { quintOut } from 'svelte/easing'
    const [send, receive] = crossfade({
        duration: 200,
        fallback: scale,
    })
    export let photos = []
    export let isOpen = false
    export let currentPhotoId = 0
    let currentItem = null
    let listItems = []
    function resolveItemPhoto(id) {
        return listItems.find(({ id }) => resolveItemPhoto) || null
    }
    $: listItems = photos.map(
        ({ id, src, desc = null, title = 'Untitled' }, i) => ({
            id: id || crypto.randomUUID(),
            src: src || photos[i],
            desc,
            title,
        })
    )
    $: currentItem = listItems.find(({ id }) => id === currentPhotoId)
    let prom
</script>

<div class="gallery-list-item">
    <!-- in:receive={{ key: id }}
    out:send={{ key: id }} -->
    {#each listItems as { id, src, title } (id)}
        <div
            transition:scale
            class="gallery-item"
            style="background-image: url('{src}')"
            title={title || 'untitled'}
        >
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
                on:click={() => {
                    currentPhotoId = id
                    isOpen = true
                }}
            >
                <span transition:fade={{ duration: 1500 }}>
                    <ShowEye color="white" size={38} />
                </span>
            </div>
        </div>
    {/each}
</div>
{#if isOpen && currentItem}
    {@const { src, title, id } = currentItem}
    <div class="viewer">
        <!-- in:receive={{ key: id }}
        out:send={{ key: id }} -->
        <img
            transition:scale
            {src}
            alt={title}
        />
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-missing-attribute -->
        <span
            style="color: white;cursor: pointer;position: absolute; top: 5px; right: 5px"
            on:click={() => (isOpen = false)}
        >
            <Close />
        </span>
    </div>
{/if}

<style>
    .gallery-list-item {
        display: flex;
        flex-wrap: wrap;
        height: auto;
        width: 100%;
        /* background-color: aqua; */
        gap: 15px;
        padding: 0;
    }
    .gallery-item {
        width: 125px;
        height: 125px;
        border-radius: 9px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto 100%;
        cursor: pointer;
        position: relative;
        transition: all 0.3s ease-in-out;
        box-shadow: var(--shadow-default);
        clip-path: fill-box;
    }

    .gallery-item:hover {
        background-size: auto 150%;
        /* transform: scale(1.05); */
    }
    .gallery-item div {
        transition: all 0.3s ease-in-out;
        display: none;
    }
    .gallery-item:hover div {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .viewer {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 99999999999999999;
        top: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.75);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .viewer img {
        width: 90%;
        height: auto;
        display: block;
        user-select: none;
        border-radius: 4px;
        position: relative;
    }
</style>
